import request from '@/utils/request'

let GroupAwardApi = {
  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.groupaward.setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.groupaward.setting/index', data, errorback);
  },
  /*获取月度业绩列表*/
  performanceList(data, errorback) {
    return request._get('/shop/plus.groupaward.Performance/index', data, errorback);
  },
  /*获取业绩详情*/
  permanceLogList(data, errorback) {
    return request._get('/shop/plus.groupaward.PerformanceLog/index', data, errorback);
  },

  /*结算单列表*/
  statementList(data, errorback) {
    return request._get('/shop/plus.groupaward.Statement/index', data, errorback);
  },

  /*获取年月*/
  getYearAndMonth(data, errorback) {
    return request._get('/shop/plus.groupaward.Statement/getYearAndMonth', data, errorback);
  },
  /*生成团队业绩结算单*/
  createStatement(data, errorback) {
    return request._get('/shop/plus.groupaward.Statement/createStatement', data, errorback);
  },

  /*获取结算单*/
  getStatement(data, errorback) {
    return request._get('/shop/plus.groupaward.Statement/getDetail', data, errorback);
  },

  /*获取结算单详情*/
  getStatementLogList(data, errorback) {
    return request._get('/shop/plus.groupaward.StatementLog/index', data, errorback);
  },

  //确认结算单
  confirmStatement(data, errorback) {
    return request._get('/shop/plus.groupaward.Statement/confirm', data, errorback);
  },

  //发放结算单
  sendStatement(data, errorback) {
    return request._get('/shop/plus.groupaward.Statement/sendRebate', data, errorback);
  },
  
  /*结算单列表*/
  teamList(data, errorback) {
    return request._get('/shop/plus.groupaward.Team/index', data, errorback);
  },
  
  /*获取年月*/
  getYearAndMonth(data, errorback) {
    return request._get('/shop/plus.groupaward.Team/getYearAndMonth', data, errorback);
  },
  /*生成团队业绩结算单*/
  createTeam(data, errorback) {
    return request._get('/shop/plus.groupaward.Team/createTeam', data, errorback);
  },
  
  /*获取结算单*/
  getTeam(data, errorback) {
    return request._get('/shop/plus.groupaward.Team/getDetail', data, errorback);
  },
  
  /*获取结算单详情*/
  getTeamLogList(data, errorback) {
    return request._get('/shop/plus.groupaward.TeamLog/index', data, errorback);
  },
  
  //确认结算单
  confirmTeam(data, errorback) {
    return request._get('/shop/plus.groupaward.Team/confirm', data, errorback);
  },
  
  //发放结算单
  sendTeam(data, errorback) {
    return request._get('/shop/plus.groupaward.Team/sendRebate', data, errorback);
  },

}
export default GroupAwardApi;



// WEBPACK FOOTER //
// ./src/api/groupaward.js